module.exports = __webpack_public_path__ + "img/LogoH35-02.701003c6.png";